import React, { useState } from "react";
import {
  ImageCarouselBase,
  Caption,
  CarouselInline,
  CarouselScroller,
  CarouselItems,
  CarouselDots,
  CarouselDot,
  CarouselItem,
  CarouselImage,
} from "./image-carousel.styled";
import { ImageCarouselSliceFragment } from "../../types/graphql";
import { htmlSerializer } from "../../utils/htmlSerializer";
import { PrismicRichText, SliceComponentProps } from "@prismicio/react";
import * as prismicHelper from "@prismicio/helpers";
import { Slice } from "@prismicio/types";
import { IPageContext } from "../../types/types";
import { SharedSliceType } from "../shared-slice/shared-slice";

export type IImageCarouselProps = Slice<
  SharedSliceType,
  ImageCarouselSliceFragment["primary"],
  ImageCarouselSliceFragment["items"][number]
> & { type: SharedSliceType.image_carousel };

const ImageCarousel = ({
  slice,
  context,
}: SliceComponentProps<IImageCarouselProps, IPageContext>) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const images = slice.items;

  function renderCaptions(imageIndex: number) {
    return (
      /* Show primary caption if it exists */
      (slice.primary?.primary_caption &&
        prismicHelper.asText(slice.primary?.primary_caption.richText) && (
          <Caption>
            <PrismicRichText
              field={slice.primary?.primary_caption.richText}
              components={htmlSerializer}
            />
          </Caption>
        )) ||
      /* Show image captions for correpsonding image if they exist and primary caption doesn't */
      images?.map(
        (entry, index) =>
          entry?.image_caption &&
          index === imageIndex && (
            <Caption key={index}>
              <PrismicRichText
                field={entry.image_caption.richText}
                components={htmlSerializer}
              />
            </Caption>
          )
      )
    );
  }

  return (
    <ImageCarouselBase>
      {images && images.length > 0 && (
        <CarouselInline>
          <CarouselScroller>
            <CarouselItems activeIndex={activeIndex}>
              {images.map(
                (entry, index) =>
                  entry?.image1?.url && (
                    <CarouselItem key={index}>
                      <CarouselImage
                        src={entry.image1.url}
                        alt={entry.image1.alt || "Xometry Image"}
                        height={entry.image1.dimensions?.height}
                        width={entry.image1.dimensions?.width}
                      />
                    </CarouselItem>
                  )
              )}
            </CarouselItems>
            {images.length > 1 && (
              <CarouselDots>
                {images.map(
                  (entry, index) =>
                    entry?.image1?.url && (
                      <CarouselDot
                        key={index}
                        onClick={() => setActiveIndex(index)}
                        isActive={activeIndex === index}
                      ></CarouselDot>
                    )
                )}
              </CarouselDots>
            )}
          </CarouselScroller>
          {renderCaptions(activeIndex)}
        </CarouselInline>
      )}
    </ImageCarouselBase>
  );
};

export default ImageCarousel;
